import { Injectable } from '@angular/core';
import { GeralGoApi, SimuladorGoApi } from '@gestor-web/@core/api/go';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class LancamentosRejeitadosFornecimentoDiretoService {
  constructor(private geralGoApi: GeralGoApi, private simuladorGoApi: SimuladorGoApi) {}

  getDataGoApi(
    regans: string,
    competenciaInicial: string,
    competenciaFinal: string,
    filtroTpSeqLancto?: string,
    filtroMotivoArquivo?: string[],
    filtroCriticaGuia?: string[],
    filtroCriticaItem?: string[],
  ) {
    return this.simuladorGoApi
      .fetchLancamentosRejeitadosFornecimentoDireto({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        tp_seq_lancto: filtroTpSeqLancto,
        filtro_motivo_arquivo: this.joinFiltro(filtroMotivoArquivo),
        filtro_critica_guia: this.joinFiltro(filtroCriticaGuia),
        filtro_critica_item: this.joinFiltro(filtroCriticaItem),
      })
      .pipe(
        map(data => ({
          items: data.items ?? [],
        })),
        catchError(() => of({ items: [] })),
      );
  }

  getFiltro() {
    return this.geralGoApi.fetchLancamentosRejeitadosOutrasDespesasFiltro().pipe(
      map(data => data.items ?? []),
      catchError(() => of([])),
    );
  }

  private joinFiltro(values?: string[]) {
    return values?.length ? values.join(':') : undefined;
  }
}
